import React from 'react'
import {Draggable} from 'react-beautiful-dnd';
import {Context} from '../Context'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faCheck, faBars} from '@fortawesome/fontawesome-free-solid'

import './Card.css'

const getItemStyle = (isDragging, draggableStyle) => ({
  // change background colour if dragging
  background: isDragging ? 'orange' : 'white',
  // styles we need to apply on draggables
  ...draggableStyle,
});

class Card extends React.Component {
  state = {
    editMode: false,
    cardDoneStyle: {}
  }

  handleTextUpdate(actions, e) {
    if (e.target.value) {
      actions.updateItem(this.props.id, e.target.value, this.props.duedate)
      e.target.value = ""
      this.setState({editMode:false})
    }
  }

  getContentLinked(content, actions) {
    let hashtags = new Set([])
    let results = content.match(/#\w+/ig)
    if (results) {
      results.forEach(result => hashtags.add(result.toLowerCase()))
    }
    const hashtagArray = Array.from(hashtags)
    var contentArray = content.split(/#\w+/ig);
    let output = []
    for (let i =0; i < contentArray.length; i ++ ) {
      let hashtag = hashtagArray.shift()
      output.push(<span className="todo-text" key={"text-"+i} onClick={() => this.setState({editMode: true})}>{contentArray[i]}</span>)
      output.push(<a key={"hashtag-"+i} className="hashtag-link" href={hashtag} onClick={() => actions.textSearch(hashtag)}>{hashtag}</a>)
    }
    /*
    contentArray = contentArray.map( (part, i) => {
      if(part) {
        return <span className="todo-text" key={i} onClick={() => this.setState({editMode: true})}>{part}</span>
      } else {
        let hashtag = hashtagArray.shift()
        return <a key={i} className="hashtag-link" href={hashtag} onClick={() => actions.textSearch(hashtag)}>{hashtag}</a>
      }
    })*/
    return <div>{output}</div>;
  }

  render() {

    return(
      <Context.Consumer>
        {
          ({globalState, actions}) =>
            <Draggable draggableId={this.props.id} index={this.props.index}>
              {(provided, snapshot) => (
                <React.Fragment>
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="card"
                    id={this.props.id}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style)}
                  >
                    {
                      this.state.editMode
                        ? <React.Fragment>
                            <textarea
                                type="text"
                                defaultValue={this.props.content}
                                onKeyPress={(e) => e.key === 'Enter' && this.handleTextUpdate(actions, e)}
                                onBlur={(e) => this.handleTextUpdate(actions, e)}
                                autoFocus
                              ></textarea>
                          </React.Fragment>
                        : <React.Fragment>
                            <div className="card-left">
                              {console.log({...this.props})}
                              <FontAwesomeIcon icon={faBars} style={{ color: 'rgba(0, 0, 0, 0.2)', padding: '0.3em' }}/>
                              {this.getContentLinked(this.props.content, actions)}
                            </div>
                            <button className="done-button" onClick={() => actions.toggleDone(this.props.id)}><FontAwesomeIcon icon={faCheck}/></button>
                          </React.Fragment>
                    }

                  </div>

                  {provided.placeholder}
                </React.Fragment>
              )}
          </Draggable>
        }
      </Context.Consumer>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js